import { render } from "./TeamWrapper.vue?vue&type=template&id=6cab1db8"
import script from "./TeamWrapper.vue?vue&type=script&lang=js"
export * from "./TeamWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__